import { AvatarGroup } from '@mui/material';
import { forwardRef } from 'react';
//
import { CustomAvatarGroupProps } from './types';

const SIZES = {
  tiny: 24,
  small: 32,
  medium: 40,
  large: 56,
};

const CustomAvatarGroup = forwardRef<HTMLDivElement, CustomAvatarGroupProps>(
  ({ size = 'small', compact, max, children, sx, ...other }, ref) => {
    const isTiny = size === 'tiny';

    const isSmall = size === 'small';

    const isMedium = size === 'medium';

    const isLarge = size === 'large';

    const compactStyle = {
      position: 'relative',
      '& .MuiAvatarGroup-avatar': {
        m: 0,
        width: isTiny ? 16 : 20,
        height: isTiny ? 16 : 20,
        position: 'absolute',
        '&:first-of-type': {
          right: isTiny ? 0 : -4,
          bottom: -4,
          zIndex: 9,
          fontSize: 8,
        },
        '&:last-of-type': {
          top: 0,
          right: 0,
        },
      },
    } as const;

    return (
      // <ThemeProvider
      // NOTE: We need to override the default background color of AvatarGroup so the "transparent" border will work
      //   theme={{
      //     ...theme,
      //     palette: {
      //       ...theme.palette,
      //       background: {
      //         ...theme.palette.background,
      //         default: 'var(--background-color)',
      //       },
      //     },
      //   }}
      // >
      <AvatarGroup
        ref={ref}
        max={compact ? 2 : max}
        spacing={((isTiny || isSmall) && 'medium') || 'small'}
        sx={{
          '& .MuiAvatar-root': {
            ...(isLarge && {
              width: SIZES.large,
              height: SIZES.large,
              '&:first-of-type': { fontSize: 16 },
            }),
            ...(isMedium && {
              width: SIZES.medium,
              height: SIZES.medium,
            }),
            ...(isSmall && {
              width: SIZES.small,
              height: SIZES.small,
            }),
            ...(isTiny && {
              width: SIZES.tiny,
              height: SIZES.tiny,
              '&:first-of-type': { fontSize: 12 },
            }),
          },
          ...(compact && { ...compactStyle }),
          ...sx,
        }}
        {...other}
      >
        {children}
      </AvatarGroup>
      // </ThemeProvider>
    );
  },
);

export default CustomAvatarGroup;
